import template from "./font-selector.html";

const FontSelectorComponent = {
  bindings: {
    defaultValue: "<",
    appendToBody: "=",
    onChange: "&",
  },
  template: template,
  controller: class FontSelectorController {
    /* @ngInject */
    constructor(fonts) {
      this.fonts = fonts;
    }

    $onInit() {
      this.model = this.defaultValue ? angular.copy(this.defaultValue) : null;
    }

    $onChanges(changesObj) {
      if (!changesObj.defaultValue.isFirstChange()) this.model = angular.copy(this.defaultValue);
    }

    change($item, $model) {
      this.onChange({ font: $model });
    }
  },
};

export default FontSelectorComponent;
